import React from "react";

export default function Footer() {
  return (
    <footer className="pic-authors">
      <a href="https://www.freepik.com/free-vector/cute-doodle-chef-hat-vector_33114696.htm#page=9&query=chef%20hat&position=11&from_view=keyword">Image by rawpixel.com on Freepik &#8226; &nbsp;</a>
      <a href="https://unsplash.com/@hermez777?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">Photo by Hermes Rivera</a><a href="https://unsplash.com/s/photos/meal?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"> on Unsplash</a>
      <a href="https://jakubbaran.dev/">© 2023 Copyright Jakub Baran</a>
    </footer>
  )
  }